module.exports = __webpack_public_path__ + "static/client12-69decd08dcbf1014a32e9ff0c3c3c7c8.png";